module.exports = __webpack_public_path__ + "img/dpi.5106e767.svg";